import React from 'react';

export const AddtionalStudent = ({
    studentInfoList,
    idx,
    removeStudentInfo,
    addStudentInfo,
    originalArr,
}: {
    studentInfoList: any[];
    idx: number;
    removeStudentInfo: (key: number) => void;
    addStudentInfo: () => void;
    originalArr: any[];
}) => {
    return (
        <div className="add-brother-container">
            {studentInfoList.length - 1 !== idx ? (
                <button
                    className="brother-button minus-brother-button"
                    onClick={() => {
                        removeStudentInfo(originalArr[idx + 1].key);
                    }}
                    type="button"
                >
                    <div className="brother-button__txt">
                        <span>형제가 있다면 함께 체험해보세요.</span>
                        <span>자녀 추가 취소</span>
                    </div>
                    <div className="brother-button__icon">
                        <img src="https://us.wink.co.kr/resources/ltp/images/common/icon-minus-white.svg" alt="삭제" />
                    </div>
                </button>
            ) : studentInfoList.length < 3 ? (
                <button className="brother-button add-brother-button" onClick={addStudentInfo} type="button">
                    <div className="brother-button__txt">
                        <span>형제가 있다면 함께 체험해보세요.</span>
                        <span className="highlight">자녀 추가하기</span>
                    </div>
                    <div className="brother-button__icon">
                        <img src="https://us.wink.co.kr/resources/ltp/images/common/icon-plus-white.svg" alt="추가" />
                    </div>
                </button>
            ) : null}
        </div>
    );
};
